export default __webpack_public_path__ + "static/media/genesys.e1c5d6d5.png";